import React from "react";
import Scheduler from "../Scheduling";

const PersonalCalendarScheduler: React.FC = () => {
    return (
        <Scheduler renderPersonalCalendarOnly={true} />
    );
};

export default PersonalCalendarScheduler;